export default __webpack_public_path__ + "static/media/landscape24.6b80492f.JPG";